import React, { useState } from "react";
import {
  Box,
  Card,
  Button,
  Container,
  TextField,
  Typography,
  CardContent,
} from "@mui/material";
import axios from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { APB, ACROSS_LOGO } from "../../assets";
import { getLanguage } from "../../utils/localization";
import LoadingSpinner from "../../components/GlobalLoading";
import { GET_CERTIFICATE_STATUS, X_API_KEY } from "../../constants";

const GETDETAILBYIMEI =
  // "https://tmagadgetapi.acrossassist.com/api/FinanceVendor/getCustomerDetailsByIMEI?";
  "https://gadgetapi.acrossassist.com/api/FinanceVendor/getCustomerDetailsByIMEI";

const CheckStatus = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [activeTab, setActiveTab] = useState("ClaimStatus");
  const [searchClaimResult, setSearchClaimResult] = useState(null);
  const [searchPolicyStatus, setSearchPolicyStatus] = useState(null);
  const [hasSearchedPolicyStatus, setHasSearchedPolicyStatus] = useState(false);

  const formik = useFormik({
    initialValues: { imei: "" },
    validationSchema: Yup.object({
      imei: Yup.string()
        .required("*IMEI is required")
        .matches(/^[0-9]+$/, "Only numbers allowed")
        .length(15, "IMEI must be exactly 15 digits"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      setHasSearched(true);
      setSearchClaimResult(null);

      const DATA = {
        serialOrIMEINumber: values?.imei,
      };

      try {
        const res = await axios.post(GETDETAILBYIMEI, DATA);

        const result = res?.data;

        if (res?.status === 200 && result) {
          setSearchClaimResult(result);
          setIsLoading(false);
        } else {
          toast.error(res?.data?.message || "No data found");
          setIsLoading(false);
        }
      } catch (err) {
        console.log("54 ==== Api Reponse Error ====", err);
        if (err?.status === 404) {
          toast.error(err?.response?.data);
          setIsLoading(false);
        } else if (err?.code === "ERR_NETWORK") {
          // toast.error("Network error. Please try again.");
          setIsLoading(false);
        } else {
          toast.error(err?.response?.data);
          setIsLoading(false);
        }
      } finally {
        setIsLoading(false);
      }
    },
  });
  const policyStatusFormik = useFormik({
    initialValues: { policyImei: "" },
    validationSchema: Yup.object({
      policyImei: Yup.string()
        .required("*IMEI is required")
        .matches(/^[0-9]+$/, "Only numbers allowed")
        .length(15, "IMEI must be exactly 15 digits"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      setHasSearchedPolicyStatus(true);
      setSearchPolicyStatus(null);

      try {
        axios(`${GET_CERTIFICATE_STATUS}${values?.policyImei}`, {
          method: "GET",
          headers: {
            "x-api-key": X_API_KEY,
            "Content-Type": "application/json",
          },
        })
          .then((res) => {
            if (res?.data?.statusCode === 200) {
              setSearchPolicyStatus(res?.data?.data);
              setIsLoading(false);
            }
            setIsLoading(false);
          })
          .catch((e) => {
            setIsLoading(false);
          });
      } catch (err) {
        if (err?.code === "ERR_NETWORK") {
          toast.error("Network error. Please try again.");
          setIsLoading(false);
        } else {
          toast.error(
            err?.response?.data?.message ||
              err?.res?.data?.message ||
              "Something went wrong"
          );
          setIsLoading(false);
        }
      } finally {
        setIsLoading(false);
      }
    },
  });

  const formattedDate = new Date(
    searchPolicyStatus?.issuesDate
  ).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <Container maxWidth="lg">
      <Row className="d-flex justify-content-between align-items-center px-0 mb-4 mt-4">
        <Col xs={6} md={6} className="d-flex align-items-center">
          <img
            alt="Apb Logo"
            className="img-fluid me-3"
            src={APB}
            width={130}
          />
          <img
            alt="Across Logo"
            className="img-fluid"
            src={ACROSS_LOGO}
            width={130}
          />
        </Col>

        <Col
          xs={12}
          md={12}
          lg={6}
          className="d-flex justify-content-end align-items-center"
        >
          <button
            className="btn gradient-btn-border me-3"
            style={{ fontSize: "0.8rem" }}
            onClick={() => navigate("/download-certificate")}
          >
            {getLanguage("PLCY_UPLD.DW_CRTFCT_BTN")}
          </button>

          <button
            className="btn gradient-btn"
            style={{ fontSize: "0.8rem" }}
            onClick={() => navigate("/admin-signin")}
          >
            {getLanguage("PLCY_UPLD.ADMN_LGN")}
          </button>
        </Col>
      </Row>

      <Box sx={styles.container}>
        <Box sx={styles.tabWrapper}>
          {[
            { id: "ClaimStatus", label: "Claim Status" },
            { id: "PolicyStatus", label: "Policy Status" },
          ].map((tab) => (
            <Button
              key={tab.id}
              onClick={() => {
                setActiveTab(tab.id);
                // setSearchResult(null);
                // setImei("");
                // setError("");
              }}
              sx={styles.tabButton(activeTab === tab.id)}
            >
              {tab?.label.toUpperCase()}
            </Button>
          ))}
        </Box>
      </Box>

      {activeTab === "ClaimStatus" ? (
        <>
          <Typography variant="h6" sx={styles.LabelTypeTxt}>
            {getLanguage("PLCYSTS.CLMHDNG")}
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <Box display="flex" justifyContent="flex-start" gap={2} mt={2}>
              <TextField
                name="imei"
                variant="outlined"
                value={formik.values.imei}
                label={getLanguage("PLCYSTS.IMEILBL")}
                onChange={(e) => {
                  formik.handleChange(e);
                  if (e.target.value.trim() === "") {
                    setSearchClaimResult(null);
                    setHasSearched(false);
                  }
                }}
                onBlur={formik.handleBlur}
                inputProps={{ maxLength: 15 }}
                error={formik.touched.imei && Boolean(formik.errors.imei)}
                helperText={formik.touched.imei && formik.errors.imei}
                sx={styles.imeiField}
              />

              <Button
                type="submit"
                variant="contained"
                sx={styles.searchButton}
              >
                {getLanguage("PLCYSTS.CLMSRCH")}
              </Button>
            </Box>
          </form>

          {searchClaimResult && (
            <Card sx={{ mt: 5, mb: 3, width: "100%" }}>
              <CardContent>
                <Typography variant="h6" sx={styles.CardHeadingTxt}>
                  {getLanguage("PLCYSTS.CLMSTSTAB")}:
                </Typography>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.CLMMDL")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchClaimResult.model}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.CLMSTATUS")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchClaimResult.caseStatus || "-"}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.CLMBRND")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchClaimResult.brand}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.CLMNMBR")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchClaimResult.certificateNumber}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.CLMCSTMRNME")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchClaimResult.customerName}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.CLMCNCRNPRSNME")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchClaimResult.concernedPersonName}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.CLMDLR")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchClaimResult.dealer}
                  </Typography>
                </Box>

                {searchClaimResult.cancelRejectReason && (
                  <Box display="flex" mb={1}>
                    <Typography sx={styles.LabelTxtStyle} mr={1}>
                      Reject Reason:
                    </Typography>
                    <Typography sx={styles.ValueTxtStyle}>
                      {searchClaimResult.cancelRejectReason}
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          )}

          {(!searchClaimResult ||
            !hasSearched ||
            Object.keys(searchClaimResult).length === 0) && (
            <Card sx={{ mt: 5, textAlign: "center", p: "70px" }}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
                alt="Not found"
                width="150"
                height="150"
              />
              <Typography variant="h6" mt={2} sx={styles.LabelTxtStyle}>
                {getLanguage("PLCYSTS.CLMNTFND")}
              </Typography>
              <Typography variant="body2" sx={styles.ValueTxtStyle}>
                {hasSearched
                  ? getLanguage("PLCYSTS.CLMNTFNDHDNG")
                  : getLanguage("PLCYSTS.CLMNTFNDDSCP")}
              </Typography>
            </Card>
          )}
        </>
      ) : (
        <>
          <Typography variant="h6" sx={styles.LabelTypeTxt}>
            {getLanguage("PLCYSTS.PLCYHDNG")}
          </Typography>

          <form onSubmit={policyStatusFormik.handleSubmit}>
            <Box display="flex" justifyContent="flex-start" gap={2} mt={2}>
              <TextField
                name="policyImei"
                variant="outlined"
                label={getLanguage("PLCYSTS.IMEILBL")}
                value={policyStatusFormik.values.policyImei}
                onChange={(e) => {
                  policyStatusFormik.handleChange(e);
                  if (e.target.value.trim() === "") {
                    setSearchPolicyStatus(null);
                    setHasSearchedPolicyStatus(false);
                  }
                }}
                onBlur={policyStatusFormik.handleBlur}
                inputProps={{ maxLength: 15 }}
                error={
                  policyStatusFormik.touched.policyImei &&
                  Boolean(policyStatusFormik.errors.policyImei)
                }
                helperText={
                  policyStatusFormik.touched.policyImei &&
                  policyStatusFormik.errors.policyImei
                }
                sx={styles.imeiField}
              />

              <Button
                type="submit"
                variant="contained"
                sx={styles.searchButton}
              >
                {getLanguage("PLCYSTS.PLCYSRCH")}
              </Button>
            </Box>
          </form>

          {searchPolicyStatus && (
            <Card sx={{ mt: 5, mb: 3, width: "550px" }}>
              <CardContent>
                <Typography variant="h6" sx={styles.CardHeadingTxt}>
                  {getLanguage("PLCYSTS.PLCYDTLS")}
                </Typography>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.PLCYMBL")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchPolicyStatus?.customerMobileNumber}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.PLCYNME")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchPolicyStatus?.userName}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.PLCYPLNNME")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchPolicyStatus?.planName}
                  </Typography>
                </Box>

                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.PLCYSTATUS")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {searchPolicyStatus?.policyStatus === 0
                      ? "In Active"
                      : searchPolicyStatus?.policyStatus === 1
                      ? "Ready To Be Activated"
                      : searchPolicyStatus?.policyStatus === 2
                      ? "Pending Diagnostic"
                      : searchPolicyStatus?.policyStatus === 3
                      ? "Pending Verification"
                      : searchPolicyStatus?.policyStatus === 4
                      ? "Activated"
                      : searchPolicyStatus?.policyStatus === 5
                      ? "Rejected"
                      : "Verify Again"}
                  </Typography>
                </Box>
                {searchPolicyStatus?.resonsForPending !== "Null" && (
                  <Box display="flex" mb={1}>
                    <Typography sx={styles.LabelTxtStyle} mr={1}>
                      {getLanguage("PLCYSTS.PLCYRSN")}
                    </Typography>
                    <Typography sx={styles.ValueTxtStyle}>
                      {searchPolicyStatus?.resonsForPending}
                    </Typography>
                  </Box>
                )}
                <Box display="flex" mb={1}>
                  <Typography sx={styles.LabelTxtStyle} mr={1}>
                    {getLanguage("PLCYSTS.PLCYPNCHDATE")}
                  </Typography>
                  <Typography sx={styles.ValueTxtStyle}>
                    {formattedDate}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          )}

          {(!searchPolicyStatus ||
            !hasSearchedPolicyStatus ||
            Object.keys(searchPolicyStatus).length === 0) && (
            <Card sx={{ mt: 5, textAlign: "center", p: "70px" }}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
                alt="Not found"
                width="150"
                height="150"
              />
              <Typography variant="h6" mt={2} sx={styles.LabelTxtStyle}>
                {getLanguage("PLCYSTS.PLCYNTFND")}
              </Typography>
              <Typography variant="body2" sx={styles.ValueTxtStyle}>
                {hasSearchedPolicyStatus
                  ? getLanguage("PLCYSTS.PLCYNTFNDHDNG")
                  : getLanguage("PLCYSTS.CLMNTFNDDSCP")}
              </Typography>
            </Card>
          )}
        </>
      )}

      <LoadingSpinner open={isLoading} />
    </Container>
  );
};

export default CheckStatus;

export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  tabWrapper: {
    display: "flex",
    bgcolor: "#fff",
    borderRadius: "50px",
    border: "1px solid #eee",
    p: "8px",
    width: { xs: "280px", sm: "290px", md: "380px" },
    height: "65px",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    mb: 3,
  },
  tabButton: (active) => ({
    textTransform: "none",
    fontSize: { xs: "0.8rem", sm: "0.85rem", md: "1rem" },
    fontFamily: "Poppins, sans-serif",
    px: { xs: 2, sm: 2, md: 4 },
    py: 1.2,
    borderRadius: "50px",
    background: active ? "#5A67D8" : "transparent",
    color: active ? "#fff" : "#777",
    "&:hover": {
      bgcolor: active ? "#5A67D8" : "transparent",
    },
    boxShadow: active ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
  }),
  imeiField: {
    width: "400px",
    "& .MuiInputLabel-root": {
      color: "black",
      fontFamily: "Poppins, sans-serif",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "black",
      },
      "&:hover fieldset": {
        borderColor: "black",
      },
      "&.Mui-focused fieldset": {
        borderColor: "black",
      },
      "& input": {
        color: "black",
        fontFamily: "Poppins, sans-serif",
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "black",
      fontFamily: "Poppins, sans-serif",
    },
  },
  searchButton: {
    height: { xs: "55px", sm: "50px", md: "55px" },
    fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
    color: "#fff",
    bgcolor: "#5A67D8",
    textTransform: "none",
    "&:hover": { bgcolor: "#4C51BF" },
    fontWeight: "600",
    fontFamily: "Poppins, sans-serif",
  },
  LabelTxtStyle: {
    color: "black",
    fontWeight: 600,
    fontFamily: "Poppins, sans-serif",
  },
  ValueTxtStyle: {
    color: "black",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
  },
  CardHeadingTxt: {
    mb: 2,
    fontWeight: "600",
    fontFamily: "Poppins, sans-serif",
  },
  LabelTypeTxt: {
    mb: 2,
    fontWeight: "600",
    fontFamily: "Poppins, sans-serif",
  },
};
